<template>
  <b-card
    no-body
    class="p-1 border"
  >
    <div class="d-flex align-items-center w-100">
      <b-img
        rounded
        :width="50"
        :src="linkStaging(data.image, 50, 50)"
        class="mr-2"
        @error="(event) => {
          event.target.src = require('@/assets/images/icons/broken-image.svg')
        }"
      />
      <div class="w-100">
        <div class="d-block mb-50">{{ data.name }}</div>
        <b-badge
          variant="light-secondary"
          class="mr-1"
        >
          {{ data.type }}
        </b-badge>
        <b-badge :variant="data.active ? 'light-success' : 'light-danger'">
          {{ data.active ? 'Aktif' : 'Tidak Aktif' }}
        </b-badge>
      </div>
    </div>
  </b-card>
</template>

<script>

import {
  BCard,
  BBadge,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BImg,
    BBadge,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>
